import { render } from "./Lote.vue?vue&type=template&id=230d02b0&scoped=true"
import script from "./Lote.vue?vue&type=script&lang=ts"
export * from "./Lote.vue?vue&type=script&lang=ts"

import "./Lote.vue?vue&type=style&index=0&id=230d02b0&scoped=true&lang=css"
import "./Lote.vue?vue&type=style&index=1&id=230d02b0&lang=css"
script.render = render
script.__scopeId = "data-v-230d02b0"

export default script